export default __webpack_public_path__ + "static/event6-9a336b241d8f068a08cb0d80190acff9.jpg";